import React, {PropsWithChildren} from 'react';
import {AnimatePresence, motion} from 'framer-motion';

interface IModalProps extends PropsWithChildren {
  show: boolean;
  handleClickBackdrop?: () => void;
}

const Modal: React.FC<IModalProps> = ({show, handleClickBackdrop = () => {}, children}) => {
  return (
    <AnimatePresence>
      {show && (
        <div className="absolute inset-0 flex justify-center items-center pb-32">
          <div className="absolute inset-0 bg-black opacity-50" onClick={handleClickBackdrop}></div>
          <motion.div
            className="relative bg-white rounded-md px-10 py-8 mx-3 shadow flex flex-col justify-center items-center max-w-sm"
            transition={{ease: 'easeOut', duration: 0.2}}
            initial={{y: 100, opacity: 0}}
            animate={{y: 0, opacity: 1}}
            exit={{y: 100, opacity: 0}}>
            {children}
          </motion.div>
        </div>
      )}
    </AnimatePresence>
  );
};

export default Modal;
